import clsx from "clsx";
import { Info } from "lucide-react";

interface TravelPackInfoCardProps {
  variant?: "cyanIncluded" | "blueIncluded" | "blueExcluded" | "outlineExcluded";
  children: React.ReactNode;
}

export default function TravelPackInfoCard({
  variant = "blueExcluded",
  children,
}: Readonly<TravelPackInfoCardProps>) {
  const baseClasses = "flex items-center justify-center gap-1 p-1 text-sm border rounded-md";

  const variants = {
    cyanIncluded: "text-white bg-brand-cyan border-brand-cyan",
    blueIncluded: "text-white bg-brand-blue border-brand-blue",
    blueExcluded: "text-brand-blue border-brand-blue",
    outlineExcluded: "text-black border-brand-blue",
  };

  return (
    <div className={clsx(baseClasses, variants[variant])}>
      <div className="flex-shrink-0">
        <Info className="h-4 w-4" />
      </div>
      <div>
        <span>{children}</span>
      </div>
    </div>
  );
}
